//Parse date string as it is into Date object
//This is used when date string has no timestamp even if there is Z (UTC) the actual date is without timestamp
export function rfc3339ToDate(strDate: any): Date {
	if (!strDate || strDate === '') {
		return null;
	}
	if (typeof (strDate) !== 'string') {
		return strDate;
	}

	let dtstr = strDate.replace(/\D/g, " ");
	let dtcomps = dtstr.split(" ");
	return new Date(
		parseInt(dtcomps[0]),
		parseInt(dtcomps[1]) - 1,
		parseInt(dtcomps[2]),
		parseInt(dtcomps[3]),
		parseInt(dtcomps[4]),
		parseInt(dtcomps[5]));
}

export function slashDateToDate(d: string): Date {
	if (d && d.indexOf('/') != -1) {
		let dp: string[] = d.split('/');
		return new Date(parseInt(dp[2]), (parseInt(dp[0]) - 1), parseInt(dp[1]));
	}
	return new Date(1, 1, 1);
}

export function dateFormat(dt: Date, format: string): string {
	let day = ("0" + dt.getDate()).slice(-2);
	let month = ("0" + (dt.getMonth() + 1)).slice(-2);
	let year = dt.getFullYear().toString();
	let h = dt.getHours();
	let ampm = (h % 12 || 12)
		+ ':' + ("0" + dt.getMinutes()).slice(-2)
		+ ' ' + (h < 12 ? 'A' : 'P') + 'M';

	switch (format) {
		case '01-02-2006 03:04 PM':
			return `${month}-${day}-${year} ${ampm}`;
		case '01/02/2006 03:04 PM':
			return `${month}/${day}/${year} ${ampm}`;
		case '01/02/2006':
			return `${month}/${day}/${year}`;

		default:
			return dt.toString();
	}
}

export function isDateSet(d: Date): boolean {
	if (d && typeof (d) === "object" && d.getFullYear() > 1901) {
		return true;
	}
	return false;
}
